import { getArrayOrEmptyArray } from 'src/app/core/array-utils';
import { InterfaceItemDto } from 'src/app/core/services/deliverable-services/items.service';
import { PropertyDefsDto, PropertyDto } from 'src/app/core/services/property-definitions-api.service';
import { DeliverableDto } from 'src/app/deliverables-admin/services/deliverables-api.service';
import { IndexHeader } from '../index-header';

export class ItemsPropertiesModel {
  numberOfFrozenColumns: number;
  propertyDefs: IndexHeader[];
  items: InterfaceItemDto[];

  constructor(props: [InterfaceItemDto[], PropertyDefsDto]) {
    this.items = props[0];
    this.numberOfFrozenColumns = props[1].numberOfFrozenColumns;
    this.propertyDefs = props[1].propertyDefs!;
  }

  get allItemsProperties() {
    return this.items.flatMap(({ properties }) => properties);
  }
}

export class DeliverablePropertiesModel<TDeliverable extends DeliverableDto> {
  deliverable: TDeliverable;
  propertyDefs: IndexHeader[];
  numberOfFrozenColumns: number;
  propertyDefsByView: PropertyDefsDto;
  allItemsProperties!: PropertyDto[];

  constructor(props: [TDeliverable, PropertyDefsDto]) {
    this.deliverable = props[0];
    this.propertyDefsByView = props[1];
    this.propertyDefs = this.propertyDefsByView.propertyDefs!;
    this.numberOfFrozenColumns = this.propertyDefsByView.numberOfFrozenColumns;
  }

  get allDeliverableProperties() {
    return this.deliverable.properties;
  }
}

export class DeliverableItemsPropertiesModel<TDeliverable extends DeliverableDto> {
  items: InterfaceItemDto[];
  deliverable: TDeliverable;
  propertyDefs: IndexHeader[];
  numberOfFrozenColumns: number;
  propertyDefsByView: PropertyDefsDto;
  allItemsProperties: PropertyDto[];
  allDeliverableProperties: PropertyDto[];

  constructor(props: [TDeliverable, PropertyDefsDto, InterfaceItemDto[]]) {
    this.deliverable = props[0];
    this.propertyDefsByView = props[1];
    this.items = props[2];
    this.propertyDefs = this.propertyDefsByView.propertyDefs!;
    this.numberOfFrozenColumns = this.propertyDefsByView.numberOfFrozenColumns;

    this.allItemsProperties = this.items.flatMap(({ properties }) => getArrayOrEmptyArray(properties));
    this.allDeliverableProperties = getArrayOrEmptyArray(this.deliverable.properties);
  }
}
